import React, { useContext, useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Spinner from '@/modules/common/components/Spinner';
import LeadsContext from '@/modules/leads/contexts/LeadsContext';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { humanizeNumber } from '~/common';

let abortController;

const TitleAdmin = (props) => {
    const leadsContext = useContext(LeadsContext);
    const count = leadsContext.count;

    const [fetching, setFetching] = useState(false);
    const [approximate, setApproximate] = useState(true);

    const getCount = () => {
        let prefix = '';
        if (!leadsContext.isFiltered(false) && (count.count === count.total)) {
            prefix += '~';
        }
        if (!approximate) {
            prefix = '';
        }
        return `${prefix}${humanizeNumber(count.count)}`;
    };

    const getTotalCount = () => {
        let prefix = (approximate) ? '~' : '';
        return `${prefix}${humanizeNumber(count.total)}`;
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleClick = () => {
        if (approximate) {
            abortController = new AbortController();
            setFetching(true);
            props.fetch.get(`/api/leads/count/?${props.router.urlSearchParams.toString()}`, abortController)
                .then(({ok, data}) => {
                    if (ok) {
                        leadsContext.setCount(data);
                        setApproximate(false);
                    }
                    setFetching(false);
                })
                .catch((error) => {
                    if (error !== 'AbortError') {
                        setFetching(false);
                    }
                })
                .finally(() => {
                    abortController = null;
                });
        }
    };

    return (
        <>
            {(fetching)
                ? <Spinner/>
                : <Typography component='span' onClick={handleClick}
                              style={{cursor: (approximate) ? 'pointer' : 'initial'}}
                >
                    <span>{getCount()}</span> из <span>{getTotalCount()}</span>
                </Typography>
            }
        </>
    );
};

let Component = TitleAdmin;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
